/**
 * Company: SPHMedia
 * Description: [Article element wrapper]
 */

import WidgetWrapper from "@routes/Home/HomePageLayout/WidgetWrapper";
import { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type ArticleElementWrapperProps = {
  children: ReactNode;
  className?: string;
};

/**
 * ArticleElementWrapper
 * Description: [Wraps article page elements]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function ArticleElementWrapper({
  children,
  className,
}: ArticleElementWrapperProps): ReactElement {
  return (
    <WidgetWrapper
      className={twMerge(
        "lg:max-w-[860px] xl:!max-w-[860px] px-4 lg:px-0",
        className,
      )}
    >
      {children}
    </WidgetWrapper>
  );
}
